// InactiveAccountsTable.jsx
import React, { useEffect, useMemo, useState } from "react";
import axios from "axios";
import Hoot from "../Hoot";
import { toast } from "react-toastify";
import moment from "moment";
import { Modal, Button as BsButton } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import { FiRefreshCw, FiCheckCircle, FiAlertTriangle, FiCalendar } from "react-icons/fi";
import { HiOutlineMail } from "react-icons/hi";
import { TbWorld } from "react-icons/tb";
import { MdOutlinePersonOff } from "react-icons/md";

/**
 * Ajustes pedidos:
 * - Só 3 widgets (KPIs) com 30% width cada um e gap
 * - Usar react-icons
 * - Customizar o alert (sem react-bootstrap Alert)
 * - Devolver full code
 */

const styles = `
:root{
  --primary:#5b5cff;
  --primary2:#7c3aed;
  --bg:#f4f6fb;
  --card:#ffffff;
  --border:#e6eaf2;
  --text:#0f172a;
  --muted:#64748b;
  --shadow: 0 14px 40px rgba(15,23,42,.08);
}

.inactive-shell{
  background:var(--bg);
  padding:10px;
}

.inactive-card{
  background:var(--card);
  border-radius:18px;
  border:1px solid var(--border);
  padding:12px 14px 14px;
  box-shadow: var(--shadow);
}

.inactive-header{
  display:flex;
  flex-wrap:wrap;
  justify-content:space-between;
  align-items:flex-start;
  gap:10px;
  margin-bottom:10px;
}
.inactive-header-title{
  font-weight:700;
  font-size:1.02rem;
  display:flex;
  align-items:center;
  gap:.55rem;
  color:var(--text);
}
.inactive-chip{
  display:inline-flex;
  align-items:center;
  gap:.35rem;
  padding:.28rem .62rem;
  border-radius:999px;
  background:linear-gradient(135deg, rgba(91,92,255,.14), rgba(124,58,237,.12));
  color:#4338ca;
  font-size:.78rem;
  font-weight:600;
  border:1px solid rgba(91,92,255,.16);
}

.inactive-toolbar{
  margin-top:6px;
  padding:10px 10px;
  border-radius:14px;
  background:linear-gradient(180deg, rgba(148,163,184,0.12), rgba(148,163,184,0.06));
  border:1px solid rgba(226,232,240,.7);
  margin-bottom:10px;
}

.small-muted{ font-size:.78rem; color:var(--muted); }

/* === KPI: 3 widgets, 30% width each + gap === */
.kpi-row{
  display:flex;
  gap:14px;
  align-items:stretch;
  margin:10px 0 12px;
  flex-wrap:wrap;
}
.kpi{
  width:30%;
  min-width: 240px;
  background:var(--card);
  border:1px solid var(--border);
  border-radius:16px;
  padding:10px 12px;
  box-shadow: 0 10px 28px rgba(2,6,23,.06);
  position:relative;
  overflow:hidden;
}
@media (max-width: 980px){
  .kpi{ width: 48%; }
}
@media (max-width: 520px){
  .kpi{ width: 100%; }
}
.kpi::before{
  content:"";
  position:absolute;
  inset:-40px -60px auto auto;
  width:120px;
  height:120px;
  border-radius:999px;
  background: radial-gradient(circle at 30% 30%, rgba(91,92,255,.18), transparent 60%);
}
.kpi-title{
  display:flex;
  align-items:center;
  gap:8px;
  font-size:.8rem;
  color:var(--muted);
  font-weight:600;
}
.kpi-value{
  margin-top:2px;
  font-size:1.18rem;
  font-weight:650;
  color:var(--text);
}
.kpi-sub{
  margin-top:2px;
  font-size:.74rem;
  color:var(--muted);
}

/* tabela desktop vs mobile */
.inactive-table-wrapper{ width:100%; }
@media (max-width:768px){
  .inactive-table-desktop{display:none;}
  .inactive-mobile-list{display:block;}
}
@media (min-width:769px){
  .inactive-table-desktop{display:block;}
  .inactive-mobile-list{display:none;}
}

.inactive-table{
  width:100%;
  border-collapse:separate;
  border-spacing:0;
  font-size:.86rem;
  color:var(--text);
}
.inactive-table thead th{
  text-align:left;
  padding:.62rem .65rem;
  font-size:.78rem;
  font-weight:650;
  color:var(--muted);
  border-bottom:1px solid var(--border);
  background:var(--card);
  position:sticky;
  top:0;
  z-index:1;
}
.inactive-table tbody td{
  padding:.62rem .65rem;
  border-bottom:1px solid var(--border);
  vertical-align:middle;
}
.inactive-table tbody tr:hover{
  background:rgba(148,163,184,0.10);
}

.pill{
  display:inline-flex;
  align-items:center;
  gap:6px;
  padding:4px 10px;
  border-radius:999px;
  font-size:.74rem;
  font-weight:600;
  border:1px solid rgba(15,23,42,.08);
  background:rgba(226,232,240,.55);
  color:#0f172a;
}
.pill svg{ opacity:.9; }

.status-badge{
  display:inline-flex;
  align-items:center;
  gap:8px;
  padding:6px 10px;
  border-radius:999px;
  font-size:.74rem;
  font-weight:650;
  border:1px solid rgba(0,0,0,.06);
  letter-spacing:.2px;
}
.status-dot{
  width:8px;height:8px;border-radius:999px;
  background:currentColor;
  box-shadow: 0 0 0 4px rgba(0,0,0,.04);
}
.s-inativo{ background: rgba(245,158,11,.18); color:#f59e0b; }

.btn-icon{
  width:34px;
  height:34px;
  border-radius:12px;
  border:1px solid rgba(226,232,240,.95);
  background:#fff;
  display:inline-grid;
  place-items:center;
  cursor:pointer;
  transition: transform .08s ease, background .12s ease;
}
.btn-icon:hover{ background: rgba(91,92,255,.06); }
.btn-icon:active{ transform: scale(.98); }
.btn-icon svg{ font-size:1.05rem; color:#334155; }

/* mobile cards */
.inactive-mobile-list{ margin-top:4px; }
.mcard{
  background:var(--card);
  border-radius:16px;
  border:1px solid var(--border);
  padding:12px 12px;
  margin:8px 0;
  box-shadow: 0 10px 26px rgba(2,6,23,.06);
}
.mrow{ display:flex; align-items:center; justify-content:space-between; gap:12px; }
.mline{ height:1px; background:var(--border); margin:10px 0; }
.mtitle{ font-weight:650; color:var(--text); font-size:.92rem; }
.msub{ color:var(--muted); font-size:.78rem; margin-top:2px; }

/* === Custom Alert === */
.soft-alert{
  border-radius:16px;
  border: 1px solid rgba(245,158,11,.30);
  background: linear-gradient(180deg, rgba(245,158,11,.18), rgba(245,158,11,.08));
  padding: 12px 12px;
  display:flex;
  gap:12px;
  align-items:flex-start;
  margin: 10px 0 12px;
}
.soft-alert-icon{
  width: 40px;
  height: 40px;
  border-radius: 14px;
  display:grid;
  place-items:center;
  background: rgba(245,158,11,.18);
  border: 1px solid rgba(245,158,11,.25);
  color: #b45309;
  flex: 0 0 auto;
}
.soft-alert-title{
  font-weight: 750;
  color: var(--text);
  margin:0;
  font-size: .92rem;
}
.soft-alert-text{
  margin: 4px 0 0;
  color: #6b7280;
  font-size: .82rem;
  line-height: 1.25rem;
}
.soft-alert-actions{
  margin-left:auto;
  display:flex;
  gap:8px;
}
.soft-alert-close{
  border: 1px solid rgba(15,23,42,.10);
  background: rgba(255,255,255,.7);
  border-radius: 999px;
  padding: 6px 10px;
  font-size: .78rem;
  font-weight: 650;
  color: #334155;
}
.soft-alert-close:hover{
  background: rgba(255,255,255,.95);
}

/* modal bonito (bootstrap) */
.pretty-modal .modal-content{
  border-radius:20px;
  border:1px solid rgba(226,232,240,.9);
  box-shadow: 0 24px 80px rgba(2,6,23,.20);
  overflow:hidden;
}
.pretty-modal .modal-header{
  border-bottom:1px solid rgba(226,232,240,.9);
  background: radial-gradient(1200px 300px at 20% 0%, rgba(91,92,255,.16), transparent 60%),
              radial-gradient(900px 260px at 90% 0%, rgba(124,58,237,.12), transparent 55%),
              #ffffff;
}
.pretty-modal .modal-title{
  font-weight:700;
  color:#0f172a;
}
`;

// ===== helpers =====
const safeValue = (v, fallback = "—") => (v === null || v === undefined || v === "" ? fallback : v);

const normalize = (str) =>
  str ? str.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase() : "";

const renderPagination = (pageCount, currentPage, setCurrentPage) => {
  if (pageCount <= 1) return null;

  const pages = [];
  const maxButtons = 7;

  if (pageCount <= maxButtons) {
    for (let i = 1; i <= pageCount; i++) pages.push(i);
  } else {
    pages.push(1);
    let start = Math.max(2, currentPage - 1);
    let end = Math.min(pageCount - 1, currentPage + 1);

    if (start > 2) pages.push("...");
    for (let i = start; i <= end; i++) pages.push(i);
    if (end < pageCount - 1) pages.push("...");
    pages.push(pageCount);
  }

  return (
    <nav>
      <ul className="pagination pagination-sm mb-0">
        <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
          <button className="page-link" onClick={() => setCurrentPage((p) => Math.max(1, p - 1))}>
            «
          </button>
        </li>

        {pages.map((p, idx) =>
          p === "..." ? (
            <li key={`ellipsis-${idx}`} className="page-item disabled">
              <span className="page-link">…</span>
            </li>
          ) : (
            <li key={p} className={`page-item ${currentPage === p ? "active" : ""}`}>
              <button className="page-link" onClick={() => setCurrentPage(p)}>
                {p}
              </button>
            </li>
          )
        )}

        <li className={`page-item ${currentPage === pageCount ? "disabled" : ""}`}>
          <button className="page-link" onClick={() => setCurrentPage((p) => Math.min(pageCount, p + 1))}>
            »
          </button>
        </li>
      </ul>
    </nav>
  );
};

const InactiveAccountsTable = () => {
  const [accounts, setAccounts] = useState([]);
  const [search, setSearch] = useState("");

  const [selectedAccount, setSelectedAccount] = useState(null);
  const [confirmOpen, setConfirmOpen] = useState(false);

  const [showHint, setShowHint] = useState(true);
  const [loading, setLoading] = useState(false);

  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  const loadAccounts = async () => {
    try {
      setLoading(true);
      const res = await axios.get(Hoot() + "users/inactive/list", { withCredentials: true });
      if (res.data?.success) {
        setAccounts(res.data?.data || []);
      } else {
        setAccounts([]);
      }
    } catch (err) {
      toast.error("Erro ao carregar contas inativas.");
    } finally {
      setLoading(false);
    }
  };

  const handleActivate = async () => {
    if (!selectedAccount?.id) return;

    try {
      setLoading(true);
      await axios.put(Hoot() + `users/activate/${selectedAccount.id}`, {}, { withCredentials: true });
      toast.success("Conta ativada com sucesso.");
      setConfirmOpen(false);
      setSelectedAccount(null);
      await loadAccounts();
    } catch (err) {
      toast.error("Erro ao ativar a conta.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadAccounts();
  }, []);

  // ===== Filtering (nome/email) =====
  const filtered = useMemo(() => {
    const q = normalize(search);
    if (!q) return accounts || [];
    return (accounts || []).filter((acc) => {
      const name = normalize(acc?.name || "");
      const email = normalize(acc?.email || "");
      return name.includes(q) || email.includes(q);
    });
  }, [accounts, search]);

  // ===== KPIs (3 widgets) =====
  const kpis = useMemo(() => {
    const total = filtered.length;

    const uniqueCountries = new Set(
      (filtered || [])
        .map((a) => (a?.country || "").trim())
        .filter(Boolean)
    ).size;

    const last7 = (filtered || []).filter((a) => {
      const d = a?.date ? new Date(String(a.date).replace(" ", "T")) : null;
      if (!d || isNaN(d.getTime())) return false;
      const diff = Date.now() - d.getTime();
      return diff <= 7 * 24 * 60 * 60 * 1000;
    }).length;

    return { total, uniqueCountries, last7 };
  }, [filtered]);

  // ===== Pagination =====
  const pageCount = Math.ceil(filtered.length / itemsPerPage) || 1;
  const paginated = filtered.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage);

  // reset page when filters change
  useEffect(() => {
    setCurrentPage(1);
  }, [search, accounts.length]);

  return (
    <>
      <style>{styles}</style>

      <div className="inactive-shell">
        <div className="inactive-card">
          {/* HEADER */}
          <div className="inactive-header">
            <div className="inactive-header-title">
              <MdOutlinePersonOff style={{ color: "var(--primary)", fontSize: 20 }} />
              <span>Contas inativas</span>
              <span className="inactive-chip">
                <i className="bi bi-people-fill" />
                {filtered.length} contas
              </span>
            </div>

            <div className="d-flex flex-wrap gap-2">
              <button
                className="btn btn-outline-dark btn-sm rounded-pill d-flex align-items-center"
                onClick={loadAccounts}
                disabled={loading}
              >
                <FiRefreshCw className="me-2" />
                Recarregar
              </button>
            </div>
          </div>

          {/* TOOLBAR (barra de pesquisa full width) */}
          <div className="inactive-toolbar">
            <div className="row g-2">
              <div className="col-12">
                <input
                  type="search"
                  className="form-control form-control-sm rounded-pill"
                  placeholder="Pesquisar por nome ou e-mail…"
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                />
              </div>
            </div>
          </div>

          {/* CUSTOM ALERT */}
          {showHint ? (
            <div className="soft-alert">
              <div className="soft-alert-icon">
                <FiAlertTriangle style={{ fontSize: 18 }} />
              </div>

              <div style={{ flex: 1 }}>
                <p className="soft-alert-title">Atenção</p>
                <p className="soft-alert-text">
                  Após ativar a conta, o utilizador deixará de ser listado aqui. Esta secção serve apenas para{" "}
                  <b>listar</b> e <b>ativar</b> contas inativas. Ative apenas contas desejadas (criadas pelo admin ou
                  solicitadas por um cliente).
                </p>
              </div>

              <div className="soft-alert-actions">
                <button className="soft-alert-close" onClick={() => setShowHint(false)}>
                  Fechar
                </button>
              </div>
            </div>
          ) : null}

          {/* KPI BOXES (3 widgets) */}
          <div className="kpi-row">
            <div className="kpi">
              <div className="kpi-title">
                <MdOutlinePersonOff style={{ color: "#0f172a" }} />
                Total (filtro)
              </div>
              <div className="kpi-value">{kpis.total}</div>
              <div className="kpi-sub">Contas inativas encontradas</div>
            </div>

            <div className="kpi">
              <div className="kpi-title" style={{ color: "#0ea5e9" }}>
                <TbWorld />
                Países
              </div>
              <div className="kpi-value">{kpis.uniqueCountries}</div>
              <div className="kpi-sub">Cobertura por país (únicos)</div>
            </div>

            <div className="kpi">
              <div className="kpi-title" style={{ color: "#6366f1" }}>
                <FiCalendar />
                Últimos 7 dias
              </div>
              <div className="kpi-value">{kpis.last7}</div>
              <div className="kpi-sub">Registadas recentemente</div>
            </div>
          </div>

          {/* TABLE + MOBILE */}
          <div className="inactive-table-wrapper">
            {/* Desktop table */}
            <div className="inactive-table-desktop">
              <table className="inactive-table">
                <thead>
                  <tr>
                    <th>Nome</th>
                    <th>Email</th>
                    <th>País</th>
                    <th>Status</th>
                    <th>Data de registo</th>
                    <th className="text-end">Ações</th>
                  </tr>
                </thead>

                <tbody>
                  {paginated.map((acc) => (
                    <tr key={acc.id}>
                      <td style={{ fontWeight: 650 }}>{safeValue(acc.name, "Sem nome")}</td>

                      <td>
                        {acc.email ? (
                          <a href={`mailto:${acc.email}`} style={{ textDecoration: "none" }}>
                            <span className="d-inline-flex align-items-center gap-2">
                              <HiOutlineMail style={{ color: "#64748b" }} />
                              {acc.email}
                            </span>
                          </a>
                        ) : (
                          <span className="small-muted">Sem email</span>
                        )}
                      </td>

                      <td>
                        <span className="pill">
                          <TbWorld />
                          {safeValue(acc.country, "—")}
                        </span>
                      </td>

                      <td>
                        <span className="status-badge s-inativo">
                          <span className="status-dot" />
                          Inativo
                        </span>
                      </td>

                      <td>
                        <span className="pill">
                          <FiCalendar />
                          {acc.date ? moment(acc.date).format("DD/MM/YYYY") : "—"}
                        </span>
                      </td>

                      <td className="text-end">
                        <button
                          className="btn-icon"
                          type="button"
                          title="Ativar conta"
                          onClick={() => {
                            setSelectedAccount(acc);
                            setConfirmOpen(true);
                          }}
                          disabled={loading}
                        >
                          <FiCheckCircle style={{ color: "#16a34a" }} />
                        </button>
                      </td>
                    </tr>
                  ))}

                  {paginated.length === 0 && (
                    <tr>
                      <td colSpan={6}>
                        <span className="small-muted">Nenhuma conta inativa encontrada.</span>
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>

            {/* Mobile cards */}
            <div className="inactive-mobile-list">
              {paginated.map((acc) => (
                <div className="mcard" key={acc.id}>
                  <div className="mrow">
                    <div>
                      <div className="mtitle">{safeValue(acc.name, "Sem nome")}</div>
                      <div className="msub">
                        {acc.email ? (
                          <span className="d-inline-flex align-items-center gap-2">
                            <HiOutlineMail />
                            {acc.email}
                          </span>
                        ) : (
                          "Sem email"
                        )}
                      </div>
                    </div>

                    <button
                      className="btn-icon"
                      type="button"
                      title="Ativar"
                      onClick={() => {
                        setSelectedAccount(acc);
                        setConfirmOpen(true);
                      }}
                      disabled={loading}
                    >
                      <FiCheckCircle style={{ color: "#16a34a" }} />
                    </button>
                  </div>

                  <div className="mline" />

                  <div className="d-flex flex-wrap gap-2">
                    <span className="status-badge s-inativo">
                      <span className="status-dot" />
                      Inativo
                    </span>

                    <span className="pill">
                      <TbWorld />
                      {safeValue(acc.country, "—")}
                    </span>

                    <span className="pill">
                      <FiCalendar />
                      {acc.date ? moment(acc.date).format("DD/MM/YYYY") : "—"}
                    </span>
                  </div>
                </div>
              ))}

              {paginated.length === 0 && (
                <span className="small-muted">Nenhuma conta inativa encontrada.</span>
              )}
            </div>
          </div>

          {/* PAGINAÇÃO (só mostra se tiver +1 página) */}
          <div className="d-flex justify-content-end mt-2">
            {renderPagination(pageCount, currentPage, setCurrentPage)}
          </div>
        </div>

        {/* MODAL CONFIRMAÇÃO */}
        <Modal
          show={confirmOpen}
          onHide={() => setConfirmOpen(false)}
          centered
          className="pretty-modal"
          backdrop="static"
          keyboard={!loading}
        >
          <Modal.Header closeButton={!loading}>
            <Modal.Title>
              <FiCheckCircle className="me-2" style={{ color: "var(--primary2)" }} />
              Confirmar ativação
            </Modal.Title>
          </Modal.Header>

          <Modal.Body>
            Deseja realmente ativar a conta de{" "}
            <b>{safeValue(selectedAccount?.name, "este utilizador")}</b>{" "}
            {selectedAccount?.email ? <>({selectedAccount.email})</> : null}?
            <div className="small-muted mt-2">
              Ao ativar, o utilizador deixa de aparecer nesta lista.
            </div>
          </Modal.Body>

          <Modal.Footer>
            <BsButton variant="secondary" size="sm" onClick={() => setConfirmOpen(false)} disabled={loading}>
              Cancelar
            </BsButton>
            <BsButton variant="primary" size="sm" onClick={handleActivate} disabled={loading}>
              {loading ? "A ativar..." : "Ativar"}
            </BsButton>
          </Modal.Footer>
        </Modal>
      </div>
    </>
  );
};

export default InactiveAccountsTable;
